<template>
  <div :id="componentId" class="sp6-story-section" :style="{ backgroundColor: bgColor }">
    <div class="sp6-block_13 flex-col">
      <div class="sp6-grid_1 flex-row">
        <div
          class="sp6-list-items_1 flex-col"
          v-for="(item, index) in list"
          :key="index"
          @click="goTo(item.url)"
        >
          <div class="sp6-image-wrapper">
            <img class="sp6-image_14" referrerpolicy="no-referrer" :src="item.imageUrl" />
            <div v-if="item.isVideo" class="sp6-video-play-btn">
              <div class="sp6-play-circle">
                <img src="/play-btn.png" alt="播放" class="sp6-play-icon" />
              </div>
            </div>
          </div>
          <span class="sp6-text_53" v-html="item.title"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'StorySection',
  props: {
    componentId: {
      type: String,
      default: 'sp_six_module_6'
    }
  },
  data() {
    return {
      bgColor: '#F3F3F3',
      list: [
        {
          articleCode: '1',
          imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGd46039b1ddbbc7f399eb81303d792e18.png',
          title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          url: '',
          isVideo: true
        },
        {
          articleCode: '2',
          imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGd46039b1ddbbc7f399eb81303d792e18.png',
          title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          url: '',
          isVideo: false
        },
        {
          articleCode: '3',
          imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNG387a09863e01f489b14d15cf44651796.png',
          title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          url: '',
          isVideo: false
        },
        {
          articleCode: '4',
          imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGd46039b1ddbbc7f399eb81303d792e18.png',
          title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          url: '',
          isVideo: false
        },
        {
          articleCode: '5',
          imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGd46039b1ddbbc7f399eb81303d792e18.png',
          title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          url: '',
          isVideo: false
        },
        {
          articleCode: '6',
          imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGd46039b1ddbbc7f399eb81303d792e18.png',
          title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          url: '',
          isVideo: false
        },
        {
          articleCode: '7',
          imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNG387a09863e01f489b14d15cf44651796.png',
          title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          url: '',
          isVideo: false
        },
        {
          articleCode: '8',
          imageUrl: 'https://lanhu-oss-2537-2.lanhuapp.com/FigmaDDSSlicePNGd46039b1ddbbc7f399eb81303d792e18.png',
          title: '国际足联对奥克兰枪击案表示哀悼，女足世界杯揭幕战今晚举行',
          url: '',
          isVideo: false
        }
      ]
    };
  },
  methods: {
    goTo(url) {
      if (!url) return;
      window.open(url, '_blank');
    }
  }
};
</script>
<style scoped>
.sp6-story-section {
  position: relative;
  width: 2000px;
  left: 50%;
  transform: translateX(-50%);
}

.sp6-story-section .sp6-block_13 {
  position: relative;
  width: 1400px;
  height: auto !important;
  margin: 0 auto;
}

.sp6-story-section .sp6-grid_1 {
  width: 1400px !important;
  height: auto !important;
  margin: 20px 0 !important;
  flex-wrap: wrap;
  gap: 23px;
}

.sp6-story-section .sp6-list-items_1 {
  cursor: pointer;
  width: 332px !important;
  height: auto !important;
  background: #F9F9F9 !important;
  background-size: 0 !important;
  border-radius: 16px;
  margin: 0 !important;
  overflow: hidden;
}

.sp6-story-section .sp6-image_14 {
  width: 332px !important;
  height: 187px !important;
  object-fit: cover;
  margin: 0 !important;
  display: block;
  vertical-align: top;
  border-radius: 16px 16px 0 0;
}

.sp6-story-section .sp6-text_53 {
  width: 100% !important;
  height: auto !important;
  margin: 12px 0 12px 0 !important;
  padding: 0 16px;
  box-sizing: border-box;
  line-height: 24px;
  text-align: center;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: rgba(102, 102, 102, 1);
  font-size: 18px;
  font-weight: 700;
}

.story-image-wrapper {
  position: relative;
  line-height: 0;
  font-size: 0;
}

.sp6-video-play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
</style>
